<template>
  <nav class="navbar has-shadow">
    <div class="navbar-brand">
      <a href="#" class="is-hidden-desktop navbar-item">UPPERCUT</a>
      <div class="navbar-burger is-block">
        <button @click="toggleSidebar" :class="{'is-active' : isActive}"
          class="button navbar-burger is-block" data-target="navMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <a href="#" class="is-hidden-touch navbar-item">UPPERCUT</a>
    </div>
    <div id="navMenu" class="navbar-menu">
      <div class="navbar-start">
      </div>
      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-item is-tab dropdown-trigger">
            <i class="fas fa-bell"></i>
            <span class="badge">10</span>
          </a>
          <div class="navbar-dropdown is-right">
            <div class="dropdown-item notifications-row">You have 10 notifications</div>
            <div class="dropdown-item notifications custom-scrollbar">
              <ul>
                <li>
                  <div><i class="fas fa-bell"></i></div>Create notifications dropdown
                </li>
                <li><div><i class="fas fa-user"></i></div>Add more buttons</li>
                <li>
                  <div><i class="fas fa-map-marker-alt"></i></div>
                  Create something special for my boss
                </li>
                <li><div><i class="fas fa-adjust"></i></div>Buy a gift form my girlfriend</li>
                <li><div><i class="fas fa-utensils"></i></div>Go eat</li>
                <li><div><i class="fas fa-shopping-cart"></i></div>Go to the supermarket</li>
                <li>
                  <div><i class="fas fa-money-bill-alt"></i></div>
                  This is a really long notification that needs to be displayed in a different page
                </li>
              </ul>
            </div>
            <div class="dropdown-item notifications-row has-text-centered">
              <a href="#">View all</a>
            </div>
          </div>
        </div>
        <a class="navbar-item is-tab">
          <span class="icon">
            <i class="fas fa-user"></i>
          </span>
        </a>
        <router-link :to="{path: '/lock'}" class="navbar-item is-tab">
          <span class="icon">
            <i class="fas fa-sign-out-alt"></i>
          </span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import bus from '@/bus';

export default {
  data() {
    return {
      isActive: false,
      notificationDropdown: false,
    };
  },
  mounted() {
    bus.$on('closeSidebar', () => {
      this.isActive = false;
    });
    bus.$on('openSidebar', () => {
      this.isActive = true;
    });
  },
  methods: {
    toggleSidebar() {
      this.isActive = !this.isActive;
      bus.$emit('toggleSidebar');
    },
  },
};
</script>
